import React from "react";
import { Toast } from "react-bootstrap";

const UploadToast = ({ toastMessage, setToastMessage, isDark }) => (
    <Toast
    show={!!toastMessage}
    onClose={() => setToastMessage("")}
    delay={3000}
    autohide
    className="position-fixed bottom-0 end-0 m-3"
    style={{
        backgroundColor: isDark ? "#333" : "#fff",
        color: isDark ? "#fff" : "#000",
        transition: "all 0.3s ease",
    }}
    >
    <Toast.Body>{toastMessage}</Toast.Body>
    </Toast>
);

export default UploadToast;
